export default __webpack_public_path__ + "static/media/1.491448e4.jpg";